import React from 'react'

import Divider from 'components/common/Divider'
import Text from 'components/common/Text'

import { Container, Button } from './styles'

import ProgressWithCopy from '../ProgressWithCopy'
import QuitestStudents from '../QuitestStudents'

const MinStats = ({
    userId,
    isTeacher,
    percentage,
    color,
    onClick,
    students = [],
}) => {
    const progressProps = {
        color,
        percentage,
        isTeacher,
    }

    const quietestStudentProps = {
        userId,
        students,
    }

    return (
        <Container>
            <ProgressWithCopy {...progressProps} />
            {students.length ? <Divider color="#fff" /> : null}
            <QuitestStudents {...quietestStudentProps} />
            <Button onClick={onClick}>
                <Text color="#60AEF5" level="3">
                    Know More
                </Text>
            </Button>
        </Container>
    )
}

export default MinStats
